@let currentLanguage = this.currentLanguage();
@let isFrench = currentLanguage === 'fr-CA';

@if (isFrench) {
  <img
    src="/images/service-center-sections/more-franchising-fr.webp"
    width="800"
    height="1109"
    alt="Franchising Promotion"
  />
} @else {
  <img
    src="/images/service-center-sections/more-franchising-en.webp"
    width="800"
    height="1109"
    alt="Franchising Promotion"
  />
}
